// src/pages/ReceiptPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Divider } from '@mui/material';
import api from '../api/index.js'; // Usamos la instancia de Axios sin token

const ReceiptPage = () => {
    const { uuid } = useParams();
    const [receiptData, setReceiptData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchReceipt = async () => {
            try {
                // Llamamos al endpoint público
                const response = await api.get(`/public/receipt/${uuid}`);
                setReceiptData(response.data);
            } catch (err) {
                setError('Recibo no encontrado o inválido.');
            } finally {
                setLoading(false);
            }
        };
        fetchReceipt();
    }, [uuid]);

    if (loading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;

    return (
        <Box sx={{ maxWidth: 600, margin: '2rem auto', p: 3, border: '1px solid #ddd', borderRadius: 2 }}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
                <img src="https://points.beer/logo_pointsbeer.png" alt="Logo" style={{ width: 150 }} />
                <Typography variant="h5" component="h1">POINTS.BEER</Typography>
                <Typography variant="h6">{receiptData.sale.store_name}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography>Fecha: {new Date(receiptData.sale.sale_date).toLocaleString()}</Typography>
            <Typography>Venta ID: {receiptData.sale.id}</Typography>
            <Divider sx={{ my: 2 }} />

            {receiptData.items.map((item, index) => (
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
                    <Typography>{item.quantity} x {item.name}</Typography>
                    <Typography>${(item.quantity * item.unit_price).toFixed(2)}</Typography>
                </Box>
            ))}

            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>TOTAL:</Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>${Number(receiptData.sale.total_amount).toFixed(2)}</Typography>
            </Box>

            <Box sx={{ textAlign: 'center', mt: 4, lineHeight: '1.6' }}>
                <Typography variant="h6">¡GRACIAS POR SU COMPRA!</Typography>
                <Typography>
                    Regístrate en <a href="https://www.beerpoint.com.mx" target="_blank" rel="noopener noreferrer">www.beerpoint.com.mx</a> para recibir
                </Typography>
                <Typography>
                    <a href="https://www.beercoin.com.mx" target="_blank" rel="noopener noreferrer" style={{ color: 'red', fontWeight: 'bold', textDecoration: 'none' }}>
                        ¡CERVEZA GRATIS!
                    </a>
                </Typography>
                <Typography>y Fabulosos Regalos</Typography>
            </Box>
        </Box>
    );
};

export default ReceiptPage;